import { ColorConf } from '@/config/color';
import { Box, styled } from '@mui/material';
import Image from 'next/image';
import AuthButtons from './AuthButtons';
import { _ContentTitleWithMarginTop, BackgroundContainer, Body1 } from './styles';

const ImageSection = styled(Box)(({ }) => ({
  justifyContent: "center",
  alignItems: "center",
  display: "flex"
}));

const __DescriptionWrapper = styled(Box)({
  display: "flex",
  position: "relative",
  borderRadius: 20,
  padding: "32px 12px 16px 16px",
  backgroundColor: ColorConf.White,
  color: ColorConf.HeroPrimaryText,
  fontWeight: 700,
  maxWidth: "434px",
});
const _ContentText = styled(Box)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 15,
  color: ColorConf.HeroSecondaryText,
  fontWeight: 500,
  marginTop: 10,
  marginBottom: 10,
  padding: 10,
  letterSpacing: "0.1em",
  lineHeight: "20px",
  textAlign: "center",
  maxWidth: "434px",
});
const _Wrapper = styled(Box)({
  position: "absolute",
  display: "flex",
  alignItems: "center",
  gap: 5,
  backgroundColor: "#FAFAFA",
  padding: "4px 16px",
  top: -15,
  left: 20,
});

const MainFeatures = () => {
  return (
    <>
      <Image src="/images/uraharu-logo.svg" alt="logo" width={190} height={45} />
      <_ContentText>
        あなたの「したい」を叶える、
        <br />
        相手を安全・簡単に見つけられるサービスです。
        <br />
        「相性が合わない」をなくしたい。
        <br />
        どこで出会えばいいのかわからない。
        <br />
        そんなお悩みを解決するために生まれました。
      </_ContentText>
      <BackgroundContainer
        sx={{
          gap: 5
        }}
      >
        <_ContentTitleWithMarginTop style={{ marginTop: 20 }}>
          <Image src="/images/uraharu-logo.svg" alt="logo" width={87} height={21} />
          でできること
        </_ContentTitleWithMarginTop>
        <__DescriptionWrapper>
          <_Wrapper>
            <img src="/images/1.avif" alt="1.avif" style={{ width: 30, height: 24, marginRight: 10 }} />
            レコメンド機能
          </_Wrapper>
          <Body1 sx={{ maxWidth: "80%" }}>
            あなたの好みや嗜好に基づきAIが最適なお相手をご提案します。
          </Body1>
          <ImageSection
            sx={{
              position: "absolute",
              bottom: 0,
              right: -20,
            }}
          >
            <Image
              src="/images/01.png"
              alt="01.png"
              height={87}
              width={87}
              style={{
                objectFit: "cover",
              }}
            />
          </ImageSection>
        </__DescriptionWrapper>
        <__DescriptionWrapper
          sx={{
            justifyContent: "flex-end",
          }}
        >
          <_Wrapper
            sx={{
              backgroundColor: "#FF999E80",
              backdropFilter: "blur(10px)",
              right: 20,
              left: "unset",
            }}
          >
            <Image src="/images/2.avif" alt="2.avif" width={32} height={21} style={{ marginRight: 10 }} />
            掲示板機能
          </_Wrapper>
          <ImageSection
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
            }}
          >
            <Image
              src="/images/02.avif"
              alt="02.avif"
              height={94}
              width={80}
              style={{
                objectFit: "cover",
              }}
            />
          </ImageSection>
          <Body1 sx={{ maxWidth: "76%" }}>
            したいことや出会いたい人の募集ができます。急な「会いたい」にも！
          </Body1>
        </__DescriptionWrapper>
        <__DescriptionWrapper>
          <_Wrapper>
            <Image src="/images/3.avif" alt="3.avif" width={32} height={25} style={{ marginRight: 10 }} />
            検索機能
          </_Wrapper>
          <Body1 sx={{ maxWidth: "80%" }}>
            好みの条件をしぼって男性に直接アプローチができます。相性や会える時間帯、エリアなどでも検索可能！
          </Body1>
          <ImageSection
            sx={{
              position: "absolute",
              top: 15,
              right: 10,
            }}
          >
            <Image
              src="/images/03.avif"
              alt="03.avif"
              width={58}
              height={64}
              style={{
                objectFit: "cover",
              }}
            />
          </ImageSection>
        </__DescriptionWrapper>
        <AuthButtons customStyles={{ position: "relative", marginBottom: -70, marginTop: 70 }} />
      </BackgroundContainer>
    </>
  )
}

export default MainFeatures